import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "250",
  height: "250",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M14.26,19.84a10.23,10.23,0,0,0,5-2,.33.33,0,0,0,.08-.47c-.33-.48-.56.28-2.71,1a8.59,8.59,0,0,1-2.4.44c-5.13.3-7.08-.14-9.86-1.49-.29-.25-.48.33.06.78C8.16,20.32,10.36,20.2,14.26,19.84Z",
        fill: "currentColor",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M21.06,6a.34.34,0,0,0-.68,0s.08,7.07.08,7.54c0,1.06.23,5.82-.39,6.53-1.79,2.08-7.16,3.8-12.92,2.05a9.09,9.09,0,0,1-2.82-1.33c-1-.86-1.06-15-1-16.33A6.4,6.4,0,0,0,5.37,5.89c2.29,1.08,5.37.86,7.91.77,2.73-.12,7.83-.8,7.78-3.52,0-1.45-2.2-2.72-3.5-2.7a.34.34,0,0,0,0,.68c1,0,2.72,1.07,2.71,2,0,.64-.59,1.3-2.09,1.8a16.36,16.36,0,0,1-4.93.66c-2.19.05-5.41.2-7.4-.74-1.27-.59-2.6-1.34-1.59-2.31C5.2,2,6,1.11,9.71.84a55.61,55.61,0,0,1,6.46.1.29.29,0,0,0,.35-.23c.08-.37-.39-.4-.77-.44C15.65.26,11.52,0,9.67,0a14.74,14.74,0,0,0-3.59.5C4.73.89,2.66,1.84,2.78,3.34c-.3,2.23,0,4.95-.11,6.43a87.65,87.65,0,0,0,.07,9.48A4.23,4.23,0,0,0,4.1,22a6.78,6.78,0,0,0,2.72,1.2c6.27,1.92,12,0,14-2.49C21.79,19.6,21.37,15.72,21.06,6Z",
        fill: "#86bd4d",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M17.82,14.6a4.63,4.63,0,0,0,2-1c.44-.51,0-.84-.35-.6s-.1.23-1.89.78c-4.39,1.34-11,.67-13.36-.53-.41-.28-.53.48,0,.74C6.91,15.49,12.67,16.49,17.82,14.6Z",
        fill: "currentColor",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M7.72,11a29.9,29.9,0,0,0,8.84-.31,7.71,7.71,0,0,0,2.35-.91.34.34,0,1,0-.36-.57c-1.87,1.08-5.46.86-7,.82-2.12,0-5.28.56-7.43-1.12-.43-.11-.36.45-.07.82C5.06,10.62,6.36,10.72,7.72,11Z",
        fill: "currentColor",
        "fill-rule": "evenodd"
      })
    ], -1)
  ])))
}
export default { render: render }